import strings from '@/strings.json';

export const localize = (value: string) : string => {
  // This is cheating (as any)
  if ((strings as any)[value]) 
    return (strings as any)[value];
  else {
    // We probably want to limit these to dev environment
    // eslint-disable-next-line no-console
    console.warn(`Localize called for value not found in strings.json: ${value}`);
    return value;
  }
};
